import type {State} from 'src/reducers';
import type {
  JOB_INFORMATION,
  MILESTONES,
  INTERVIEW_FLOW,
  JOB_STAGES,
  JOB_HIRING_TEAM,
  EmployeeRole,
  ApprovalObject,
  JOB_HIRING_STEPS,
  JOB_SCORE_CARDS,
  SCORE_CARD_CONFIG_RESPONSE,
  FEEDBACK_CONFIG_RESPONSE,
  STEP_QUESTIONNAIRE_SECTIONS_RESPONSE,
  USER_BASE_INFO,
  PENDING_APPROVALS,
  ApprovalStatus,
  Tag,
  HIERARCHY_LEVEL,
  OFFERS_CANDIDATE_INFO,
  CANDIDATE_JOB_STEPS,
  Candidate,
  RESUME_PARSING,
  CANDIDATE_FEEDBACK,
  INTERVIEW_SCHEDULE,
  HM_EXPERIENCE_SURVEY,
  ApplicantList,
  ApplicantListFilterMetadata,
  CandidateList,
  UNTRIED_COUNT,
  FILTERED_JOB_PAYLOAD,
  FILTERED_JOB_SELECTED,
  AI_SUMMARY,
  EVALUATION,
  VOICE_PHONE_NUMBERS_AND_BOTS,
  EvaluationFormDraft,
  CANDIDATE_FEEDBACK_RESPONSE,
  HM_EXPERIENCE_SURVEY_RESPONSE,
} from 'src/types/crm';


export const selectJobInformation = (state: State): JOB_INFORMATION =>
  state.crm.job_information;

export const selectApprovalStatus = (state: State): ApprovalStatus =>
  // @ts-expect-error - TS2339 - Property 'approvalStatus' does not exist on type 'never'.
  state.crm.approvalStatus;

export const selectPendingApprovals = (state: State): PENDING_APPROVALS =>
  // @ts-expect-error - TS2339 - Property 'pending_approvals' does not exist on type 'never'.
  state.crm.pending_approvals;

export const selectUserInfo = (state: State): USER_BASE_INFO =>
  // @ts-expect-error - TS2339 - Property 'user_info' does not exist on type 'never'.
  state.crm.user_info;

export const selectGrades = (state: State): JOB_INFORMATION =>
  // @ts-expect-error - TS2339 - Property 'grades' does not exist on type 'never'.
  state.crm.grades;

export const selectLocations = (state: State): JOB_INFORMATION =>
  // @ts-expect-error - TS2339 - Property 'locations' does not exist on type 'never'.
  state.crm.locations;

export const selectDepartments = (state: State): JOB_INFORMATION =>
  // @ts-expect-error - TS2339 - Property 'departments' does not exist on type 'never'.
  state.crm.departments;

export const selectJobCustomFields = (state: State): JOB_INFORMATION =>
  // @ts-expect-error - TS2339 - Property 'jobCustomFields' does not exist on type 'never'.
  state.crm.jobCustomFields;

export const selectMilestones = (state: State): MILESTONES =>
  // @ts-expect-error - TS2339 - Property 'milestones' does not exist on type 'never'.
  state.crm.milestones;

export const selectJobInterviewFlow = (state: State): INTERVIEW_FLOW =>
  // @ts-expect-error - TS2339 - Property 'jobInterviewFlow' does not exist on type 'never'.
  state.crm.jobInterviewFlow;

export const selectJobInterviewFlowByCandidateId =
  (candidateId: string | null | undefined) =>
  (state: State): INTERVIEW_FLOW | null | undefined => {
    if (!candidateId) {
      return undefined;
    }
    return state.crm?.jobInterviewFlowByCandidateId?.[candidateId] ?? null;
  };

export const selectApprovalRequestTime = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'approvalRequestTime' does not exist on type 'never'.
  state.crm.approvalRequestTime;

export const selectJobHiringStages = (state: State): JOB_STAGES =>
  // @ts-expect-error - TS2339 - Property 'jobHiringStages' does not exist on type 'never'.
  state.crm.jobHiringStages;

export const selectHiringTeam = (state: State): JOB_HIRING_TEAM =>
  // @ts-expect-error - TS2339 - Property 'jobHiringTeam' does not exist on type 'never'.
  state.crm.jobHiringTeam;

export const selectJDGenCompanyInfo = (state: State): JOB_INFORMATION =>
  // @ts-expect-error - TS2339 - Property 'jdGenCompanyInfo' does not exist on type 'never'.
  state.crm.jdGenCompanyInfo;

export const selectApprovals = (state: State): ApprovalObject =>
  // @ts-expect-error - TS2339 - Property 'approvals' does not exist on type 'never'.
  state.crm.approvals;

export const selectEmployeeRoles = (state: State): EmployeeRole[] =>
  // @ts-expect-error - TS2339 - Property 'employeeRoles' does not exist on type 'never'.
  state.crm.employeeRoles;

export const selectJobSteps = (state: State): JOB_HIRING_STEPS =>
  // @ts-expect-error - TS2339 - Property 'jobSteps' does not exist on type 'never'.
  state.crm.jobSteps;

export const selectCandidateJobSteps = (state: State): CANDIDATE_JOB_STEPS[] =>
  // @ts-expect-error - TS2339 - Property 'candidateJobSteps' does not exist on type 'never'.
  state.crm.candidateJobSteps;

export const selectJobScoreCards = (state: State): JOB_SCORE_CARDS =>
  // @ts-expect-error - TS2339 - Property 'jobScoreCards' does not exist on type 'never'.
  state.crm.jobScoreCards;

export const selectJobScoreCardConfig = (
  state: State,
): SCORE_CARD_CONFIG_RESPONSE[] =>
  // @ts-expect-error - TS2339 - Property 'jobScorecardConfigData' does not exist on type 'never'.
  state.crm.jobScorecardConfigData;

export const selectFeedbackConfiguration = (
  state: State,
): FEEDBACK_CONFIG_RESPONSE =>
  // @ts-expect-error - TS2339 - Property 'feedbackConfiguration' does not exist on type 'never'.
  state.crm.feedbackConfiguration;

export const selectStepQuestionnaireSection = (
  state: State,
): STEP_QUESTIONNAIRE_SECTIONS_RESPONSE =>
  // @ts-expect-error - TS2339 - Property 'stepQuestionnaireSection' does not exist on type 'never'.
  state.crm.stepQuestionnaireSection;

export const selectSelectedQuestionnaire = (state: State): JOB_STAGES =>
  // @ts-expect-error - TS2339 - Property 'selectedQuestionnaireSection' does not exist on type 'never'.
  state.crm.selectedQuestionnaireSection;

// selectedQuestionnaireSection

export const selectJobMatches = (state: State): CandidateList | null =>
  state.crm.jobMatches;

export const selectTags = (state: State): Tag[] =>
  // @ts-expect-error - TS2339 - Property 'tags' does not exist on type 'never'.
  state.crm.tags;

export const selectHierarchyLevel = (state: State): HIERARCHY_LEVEL[] =>
  // @ts-expect-error - TS2339 - Property 'hierarchyLevels' does not exist on type 'never'.
  state.crm.hierarchyLevels;

export const selectFilteredJobList = (state: State): HIERARCHY_LEVEL[] =>
  // @ts-expect-error - TS2339 - Property 'filteredJobList' does not exist on type 'never'.
  state.crm.filteredJobList;

export const selectPendingOfferCandidateDetails = (
  state: State,
): OFFERS_CANDIDATE_INFO =>
  // @ts-expect-error - TS2339 - Property 'selectedPendingOfferCandidate' does not exist on type 'never'.
  state.crm.selectedPendingOfferCandidate;

export const selectApplicantInformation = (state: State): Candidate =>
  // @ts-expect-error - TS2339 - Property 'applicantInformation' does not exist on type 'never'.
  state.crm.applicantInformation;

export const selectParsingCandidate = (state: State): RESUME_PARSING =>
  // @ts-expect-error - TS2339 - Property 'candidateParsing' does not exist on type 'never'.
  state.crm.candidateParsing;

export const selectUntriedCount = (state: State): UNTRIED_COUNT =>
  // @ts-expect-error - TS2339 - Property 'untriedCount' does not exist on type 'never'.
  state.crm.untriedCount;

export const selectCandidateFeedbacks = (
  state: State,
): CANDIDATE_FEEDBACK_RESPONSE =>
  // @ts-expect-error - TS2339 - Property 'candidateFeedbacks' does not exist on type 'never'.
  state.crm.candidateFeedbacks;

export const selectCandidateInterviewSchedules = (
  state: State,
): INTERVIEW_SCHEDULE[] =>
  // @ts-expect-error - TS2339 - Property 'candidateInterviewSchedules' does not exist on type 'never'.
  state.crm.candidateInterviewSchedules;

export const selectCandidateHmExperienceSurveys = (
  state: State,
): HM_EXPERIENCE_SURVEY_RESPONSE =>
  // @ts-expect-error - TS2339 - Property 'candidateHmExperienceSurveys' does not exist on type 'never'.
  state.crm.candidateHmExperienceSurveys;

export const selectCompletedCandidateFeedbacks = (
  state: State,
): CANDIDATE_FEEDBACK[] =>
  // @ts-expect-error - TS2339 - Property 'completedCandidateFeedbacks' does not exist on type 'never'.
  state.crm.completedCandidateFeedbacks;

export const selectCompletedInterviewSchedules = (
  state: State,
): INTERVIEW_SCHEDULE[] =>
  // @ts-expect-error - TS2339 - Property 'completedInterviewSchedules' does not exist on type 'never'.
  state.crm.completedInterviewSchedules;

export const selectCompletedHmExperienceSurveys = (
  state: State,
): HM_EXPERIENCE_SURVEY[] =>
  // @ts-expect-error - TS2339 - Property 'completedHmExperienceSurveys' does not exist on type 'never'.
  state.crm.completedHmExperienceSurveys;

export const selectApplicantList = (state: State): ApplicantList =>
  // @ts-expect-error - TS2339 - Property 'applicantList' does not exist on type 'never'.
  state.crm.applicantList;

export const selectApplicantListByStage = (
  state: State,
  stageId: number,
): ApplicantList | null => {
  const applicantListByStage = state.crm.applicantListByStage;
  return applicantListByStage?.[stageId] || null;
};

export const selectApplicantListFilterMetadata = (
  state: State,
): ApplicantListFilterMetadata =>
  // @ts-expect-error - TS2339 - Property 'applicantListFilterMetadata' does not exist on type 'never'.
  state.crm.applicantListFilterMetadata;

export const selectApplicantDetails = (state: State): Candidate[] =>
  // @ts-expect-error - TS2339 - Property 'applicantDetails' does not exist on type 'never'.
  state.crm.applicantDetails;

export const selectCandidateList = (state: State): CandidateList =>
  // @ts-expect-error - TS2339 - Property 'candidateList' does not exist on type 'never'.
  state.crm.candidateList;

export const selectHasCrmPermission = (
  userInfo: USER_BASE_INFO,
  permission: string,
): boolean => {
  try {
    const {user} = userInfo || {};

    if (user) {
      const {permissions, roleTitle} = user;
      if (roleTitle === 'MASTER') {
        return true;
      }
      return permissions.includes(permission);
    }
    return false;
  } catch (err) {
    console.error(err, 'permission check');
    return false;
  }
};

export const selectStoredJobFilters = (
  state: State,
): {
  selectedFilters: FILTERED_JOB_PAYLOAD | null;
  rawFilteredSelected: FILTERED_JOB_SELECTED | null;
  selectedJobStatuses: string[] | null;
  searchedText: string;
  isMyJobSelected: boolean;
} => state.crm.storedJobFilters;

export const selectOverviewDataAISummary = (state: State): AI_SUMMARY =>
  state.crm.overviewData.aiSummary;

export const selectOverviewDataEvaluation = (state: State): EVALUATION =>
  state.crm.overviewData.evaluation;

export const selectOverviewDataVoiceCallInfo = (state: State): any =>
  state.crm.overviewData.voiceCallInfo;

export const selectVoicePhoneNumbersAndBots = (
  state: State,
): VOICE_PHONE_NUMBERS_AND_BOTS => state.crm.voicePhoneNumbersAndBots;
